import { render, staticRenderFns } from "./fpdvender.vue?vue&type=template&id=4460b8a1&scoped=true&"
import script from "./fpdvender.vue?vue&type=script&lang=js&"
export * from "./fpdvender.vue?vue&type=script&lang=js&"
import style0 from "./fpdvender.vue?vue&type=style&index=0&id=4460b8a1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4460b8a1",
  null
  
)

export default component.exports